import { EventEmitter, type IEventEmitter } from '../../../system';
import { AngularInjector } from '../../../system/angular';

export interface IGridStrategy extends IEventEmitter {
    getGridHeight(): number;
    getGridPageAmount(): number;
    addHeader(headerHeight?: number): void;
    showPagination(): boolean;
    getCssClasses(): string;
    getInnerGridHeight(): number;
    isStretchable(): boolean;
    usesAllItems(): boolean;
    detach(): void;
    setGridElement(gridElement: HTMLElement): void;
}

export abstract class AbstractGridStrategy extends EventEmitter implements IGridStrategy {
    protected headerHeight = 0;
    public a9GridConstants = null;
    protected gridHeight = 0;
    protected itemsOnPage = 0;
    protected classes = '';

    public abstract getGridHeight(): number;
    public abstract getGridPageAmount(): number;
    public abstract showPagination(): boolean;
    public abstract detach(): void;
    public abstract setGridElement(gridElement: HTMLElement): void;

    protected constructor() {
        super();
        this.a9GridConstants = <any>AngularInjector.get('a9GridConstants');
    }

    public addHeader(headerHeight = 0): void {
        this.headerHeight += headerHeight;
    }

    public getCssClasses() {
        return this.classes;
    }

    public addClass(name) {
        this.classes += ' ' + name;
    }

    public getInnerGridHeight() {
        return this.getGridHeight() - this.headerHeight;
    }

    public isStretchable() {
        return false;
    }

    public usesAllItems(): boolean {
        return false;
    }
}
